import app from '../app.first';
import $ from 'jquery';

app.RecruiterCampaign = class extends app.Component {
    constructor($this) {
        super($this);
		$(() => this.onDocumentReady($this));
	}
    
	onDocumentReady($this) {
        $('#campaign-start').fdatepicker();
        $('#campaign-start').parent().addClass('datepicker-input');

        /**
         * slider for candidate lock-in period in days
         */
         $('#candidate-lock-in-days').parent().append('<span></span>');
         $('#candidate-lock-in-days').on('input', e => {
             const $input = $(e.target);
             $input.siblings('span').text($input.val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' days');
         }).trigger('input');
    }
}